export default (key = '') => {
  if (key) {
    return require(`./${key}.png`)
  }
  return ''
}
